import classNames from 'classnames';

import {SavedSettingToast} from '../../saved-setting-toast/saved-setting-toast';
import type {SavedSettingToastState} from '../../saved-setting-toast/saved-setting-toast';
import {Body} from '../../typography/body';

import styles from './setup-container.module.css';

interface Props {
    header: string;
    subtitle?: string;
    children?: React.ReactNode;
    savedState?: SavedSettingToastState;
    shouldCenterContent?: boolean;
    noContentPadding?: boolean;
}

export function SetupContainer(props: Props) {
    const hasSubtitle = props.subtitle != null;

    const contentContainerClassName = classNames('flex flex-dir-col gap-16 overflow-auto', {
        'justify-center align-center flex-grow': props.shouldCenterContent,
    });

    const childrenPaddingClassName = classNames({
        'pad-16': !props.noContentPadding && !hasSubtitle,
        'px-16 pb-16': !props.noContentPadding && hasSubtitle,
        'py-16': props.noContentPadding && !hasSubtitle,
    });

    return (
        <div className='flex flex-dir-col full-width full-height overflow-hidden border br-8'>
            <div className={styles.header}>
                <SavedSettingToast state={props.savedState || 'initial'}>
                    <Body isBold={true} color='dark'>
                        {props.header}
                    </Body>
                </SavedSettingToast>
            </div>
            <div className={contentContainerClassName}>
                {hasSubtitle && (
                    <div className='px-16 pt-16'>
                        <Body color='light' size='small'>
                            {props.subtitle}
                        </Body>
                    </div>
                )}
                <div className={childrenPaddingClassName}>{props.children}</div>
            </div>
        </div>
    );
}
